"use client";

import "./globals.css";

import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { Button } from "@repo/ui";
import { GeistSans } from "geist/font/sans";
import { useEffect } from "react";

// global-error replaces the root layout when the layout itself throws, so it
// must render its own <html>/<body> and cannot rely on the app's providers or
// theme. Kept intentionally minimal and self-contained.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    addNextjsError(error);
    console.error(error);
  }, [error]);

  return (
    <html lang="en" suppressHydrationWarning>
      <body className={GeistSans.className}>
        <div className="bg-background text-foreground flex min-h-screen flex-col items-center justify-center text-center">
          <h1 className="text-4xl font-normal tracking-tight sm:text-5xl">
            Something went wrong!
          </h1>
          <p className="text-muted-foreground mt-4 text-lg">
            We encountered an error while loading this page.
          </p>
          <div className="mt-10">
            <Button onClick={reset} className="rounded-full">
              Try again
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
